var map = {
	"./WorkExample.vue": "8a5f",
	"./WorkExampleDialog.vue": "4cca",
	"./WorkExampleEditorSlides.vue": "0ea8",
	"./WorkExampleSlides.vue": "00ed",
	"./WorkExamplesEditor.vue": "c84d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "87e6";